<script setup lang="ts">
// Выбор узла — первый шаг на десктопе (в вебе адрес известен из адресной строки). Разметка та же, что
// у первого экрана входа в прототипе Дизайна: знак, заголовок, поле адреса, подпись.
import { ref } from "vue";

import { useSession } from "../stores/session.ts";

const session = useSession();
const address = ref("");
const error = ref("");
const busy = ref(false);

async function submit(): Promise<void> {
  busy.value = true;
  error.value = "";
  try {
    const url = address.value.trim();
    await session.setNode(url.startsWith("http") ? url : `https://${url}`);
  } catch (err) {
    error.value = err instanceof Error ? err.message : String(err);
  } finally {
    busy.value = false;
  }
}
</script>

<template>
  <div class="y-center">
    <form class="y-auth y-stack" @submit.prevent="submit">
      <div>
        <div class="y-auth-title">Вход в Yofis</div>
        <div class="y-auth-sub">Укажите адрес сервера вашей компании</div>
      </div>
      <label class="y-field">
        <input v-model="address" class="y-input" name="node" placeholder="chat.company.ru" autocomplete="url">
      </label>
      <div v-if="error" class="y-auth-err">{{ error }}</div>
      <button class="y-btn primary lg" type="submit" :disabled="busy">
        {{ busy ? "Проверяем…" : "Продолжить" }}
      </button>
      <div class="y-auth-foot">Адрес даёт администратор вашей компании</div>
    </form>
  </div>
</template>
